import { FC } from 'react';
import styles from './CloseBtnCross.module.scss';
import { crossNew } from '../../../assets';

const CloseBtnCross: FC<{ onClick?: () => void; className?: string }> = ({ onClick, className }) => {
    return (
        <button
            className={`${styles.closeButtonCross} ${className ?? ''}`}
            onClick={onClick}>
            <img
                src={crossNew}
                alt=""
            />
        </button>
    );
};

export default CloseBtnCross;
